import device from "utils/device";
import styled, { css } from "styled-components";

export const TableWrapper = styled.div`
  ${({ theme }) => css`
    @media ${device.tablet} {
      width: ${p => p.width ?? '100%'};
      flex-grow: 1;
      overflow: auto;
      padding-right: 10px;
      
      scrollbar-width: thin;
      scrollbar-color: #E3E3E3 transparent;

      ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      /* Track */
      ::-webkit-scrollbar-track {
        border-radius: 10px;
      }
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${theme?.colour?.primary};
      }
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${theme?.colour?.primary};
      }
    }
  `}
`;